// Facturation > « À valider » (Q-clients, 02/11/2026) : encaissements du relevé
// encore en attente, avec la facture proposée, le client et où agir (miroir de
// l'onglet « À valider » des achats).
import { useCallback, useEffect, useState } from "react";
import api from "../services/api";
import InvoicePdfButton from "./InvoicePdfButton";
import DocBadge from "./DocBadge";

const fmt = (n) => Number(n || 0).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const fmtDate = (d) => (d ? String(d).slice(0, 10).split("-").reverse().join("/") : "—");

export default function SalesInflowsToValidate({ onNavigate }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const load = useCallback(() => { setError(""); api.invoices.inflowsToValidate().then(setData).catch(e => setError(e.message)); }, []);
  useEffect(() => { load(); }, [load]);
  const openImport = (importId) => {
    try { if (importId) sessionStorage.setItem("execpro360.openImport", String(importId)); } catch { /* facultatif */ }
    onNavigate?.("banque");
  };
  const th = { padding: "7px 10px", textAlign: "left", fontWeight: 600 };
  const td = { padding: "7px 10px" };
  return (
    <div style={{ marginTop: 22, border: "1px solid #e5e7eb", borderRadius: 10, overflow: "hidden" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, flexWrap: "wrap", padding: "10px 12px" }}>
        <div>
          <div style={{ fontWeight: 700 }}>Encaissements du relevé en attente {data ? `(${data.counts.inflows}, dont ${data.counts.with_proposal} avec une facture proposée)` : ""}</div>
          <div style={{ fontSize: 12, color: "#6b7280", marginTop: 2 }}>Pour relier un encaissement à sa facture : Comptes bancaires > « 🔎 Proposer les factures », onglet « Encaissements ».</div>
        </div>
        <button className="btn" style={{ fontSize: 12 }} onClick={load}>↻ Actualiser</button>
      </div>
      {error && <div style={{ background: "#e24b4a22", color: "#e24b4a", padding: "8px 12px", fontSize: 13 }}>{error}</div>}
      {!data ? <div style={{ padding: 12, fontSize: 13, color: "#6b7280" }}>Chargement…</div> : data.inflows.length === 0 ? (
        <div style={{ padding: "0 12px 12px", fontSize: 13, color: "#6b7280" }}>Aucun encaissement en attente.</div>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12.5 }}>
            <thead><tr style={{ background: "#f8fafc", fontSize: 11, color: "#6b7280", textTransform: "uppercase" }}>
              <th style={th}>Date</th><th style={th}>Libellé</th><th style={{ ...th, textAlign: "right" }}>Montant</th><th style={th}>Client</th><th style={th}>Facture(s) proposée(s)</th><th style={th} />
            </tr></thead>
            <tbody>{data.inflows.map(o => (
              <tr key={o.id} style={{ borderTop: "1px solid #f3f4f6" }}>
                <td style={td}>{fmtDate(o.date)}</td>
                <td style={td}>{o.label}</td>
                <td style={{ ...td, textAlign: "right", fontWeight: 600 }}>{fmt(o.amount)} €</td>
                <td style={td}>{o.client_name || <span style={{ color: "#6b7280" }}>non reconnu</span>}</td>
                <td style={td}>
                  {o.proposal ? (
                    <>
                      {o.proposal.invoices.map(x => <span key={x.invoice_id} style={{ fontFamily: "monospace", marginRight: 6 }}><DocBadge kind="vente" />{x.number} <InvoicePdfButton kind="vente" id={x.invoice_id} /></span>)}
                      <div style={{ fontSize: 11, color: o.proposal.certain ? "#166534" : "#b45309" }}>{o.proposal.certain ? "certaine" : "à vérifier"} — {o.proposal.reason}</div>
                    </>
                  ) : <span style={{ color: "#6b7280" }}>aucune</span>}
                </td>
                <td style={{ ...td, whiteSpace: "nowrap" }}><button className="btn" style={{ fontSize: 11, padding: "3px 8px" }} onClick={() => openImport(o.import_id)}>{o.proposal ? "Relier →" : "Ouvrir le relevé →"}</button></td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
